/**
 * author: Soumya Shreyas
 * Edit Dropdown for company listing pages
 */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

function CompanyListingEditDropdown({
  t,
  editStatus,
  resendStatus,
  revokeStatus,
  invitation,
  handleResend,
  handleEdit,
  handleRevoke
}) {
 
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="blank_outline" id="dropdown-basic">
          <BiDotsHorizontalRounded />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {editStatus && (
             <Dropdown.Item href="#" onClick={handleEdit}>
              {t("Edit.label")}
            </Dropdown.Item>
          )}
          {resendStatus && (
            <Dropdown.Item href="#" onClick={handleResend}>
              {t("Resend.label")}
            </Dropdown.Item>
          )}
          { revokeStatus && (
          <Dropdown.Item href="#" onClick={handleRevoke}>
              {t("Revoke.label")}
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
CompanyListingEditDropdown.propTypes = {
  editStatus: PropTypes.bool.isRequired,
  resendStatus: PropTypes.bool.isRequired,
  invitation: PropTypes.number.isRequired,
  handleResend: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyListingEditDropdown);
